import React from 'react';
import { PaymentRow, PaymentSkeletonRow } from './SubscriptionsPayment.style';
import { IonSkeletonText } from '@ionic/react';
import SubscriptionAdvantages from '../../components/SubscriptionAdvantages';

const SubscriptionsPaymentSkeleton = () => {
  return (
    <>
      <PaymentSkeletonRow style={{ columnGap: '16px', marginBottom: '31px' }}>
        <IonSkeletonText
          animated
          style={{
            margin: 0,
            padding: 0,
            width: '62px',
            height: '62px',
            borderRadius: '50%',
          }}
        />
        <IonSkeletonText
          animated
          style={{
            margin: 0,
            padding: 0,
            flex: 1,
            height: '59px',
            borderRadius: '6px',
          }}
        />
      </PaymentSkeletonRow>
      <PaymentSkeletonRow
        style={{
          columnGap: '23px',
          marginBottom: '28px',
          alignItems: 'flex-start',
        }}
      >
        <IonSkeletonText
          animated
          style={{
            margin: 0,
            padding: 0,
            flex: 1,
            height: '73px',
            borderRadius: '6px',
          }}
        />
        <IonSkeletonText
          animated
          style={{
            margin: 0,
            padding: 0,
            width: '80px',
            height: '42px',
            borderRadius: '6px',
          }}
        />
      </PaymentSkeletonRow>
      <IonSkeletonText
        animated
        style={{
          margin: 0,
          padding: 0,
          width: '100%',
          height: '40px',
          borderRadius: '6px',
          marginBottom: '24px',
        }}
      />
      <IonSkeletonText
        animated
        style={{
          margin: 0,
          padding: 0,
          width: '100%',
          height: '48px',
          borderRadius: '6px',
          marginBottom: '20px',
        }}
      />
      <SubscriptionAdvantages isLoading={true} style={{ marginBottom: '25px' }} />
      <PaymentRow>
        <IonSkeletonText
          animated
          style={{
            margin: 0,
            padding: 0,
            width: '100%',
            height: '97px',
            borderRadius: '6px',
          }}
        />
      </PaymentRow>
      <PaymentRow>
        <PaymentSkeletonRow
          style={{
            columnGap: '16px',
            marginBottom: '19px',
            alignItems: 'flex-start',
          }}
        >
          <IonSkeletonText
            animated
            style={{
              margin: 0,
              padding: 0,
              width: '30px',
              height: '30px',
              borderRadius: '6px',
            }}
          />
          <IonSkeletonText
            animated
            style={{
              margin: 0,
              padding: 0,
              flex: 1,
              height: '54px',
              borderRadius: '6px',
            }}
          />
        </PaymentSkeletonRow>
        <PaymentSkeletonRow
          style={{
            columnGap: '16px',
            alignItems: 'flex-start',
          }}
        >
          <IonSkeletonText
            animated
            style={{
              margin: 0,
              padding: 0,
              width: '30px',
              height: '30px',
              borderRadius: '6px',
            }}
          />
          <IonSkeletonText
            animated
            style={{
              margin: 0,
              padding: 0,
              flex: 1,
              height: '54px',
              borderRadius: '6px',
            }}
          />
        </PaymentSkeletonRow>
      </PaymentRow>
    </>
  );
};

export default SubscriptionsPaymentSkeleton;
